// eslint-disable-next-line import/prefer-default-export
export const SKYSCAPE_BASKET_ERROR_CODES = ['fast_selling_item_sold_out', 'max_quantity_exceeded'];
